import * as loader from "../file-loader/utils/utils";
import { apiFetch } from "../../services/api-fetch";
import { getMediaUrl } from "../../services/helpers/get-media-url";
import Toast from "../modal/toast";

const initUserpicLoader = () => {
  
  let userpic = document.querySelector('[data-userpic-loader]');

  if (!userpic) return;

  let userpicLoader = userpic.querySelector('[data-load-button]');
  let userpicImage = userpic.querySelector('img');

  if (!userpicLoader || !userpicImage) return;

  let action = userpicLoader.dataset.action;

  userpicLoader.addEventListener("click", () => {
    loader.selectFiles()
      .then(res => {
        let file = res.files[0];
        let data = new FormData();
        data.append('image', file);
        data.append('tokenAvatar', userpicLoader.dataset.token);

        apiFetch(action, {
          method: 'POST',
          body: data
        }).then(res => {
          if (res.success) {
            userpicImage.src = getMediaUrl(res.file.url);
          } else {
            throw new Error(res.error);
          }
        }).catch(err => {
          console.error(err);
          Toast.open("Не удалось загрузить изображение", {
            state: "error"
          });
        })
      })
  })
}

export { initUserpicLoader };